import type { AdminBrandCreateRequest } from "api/types/brand.types";

/** 백엔드 계약: 정규화(trim + 내부 연속 공백 축약) 후 1~100자 */
export const BRAND_NAME_MAX_LENGTH = 100;
export const BRAND_DESCRIPTION_MAX_LENGTH = 1000;

/** 기본 브랜드는 이름변경·비활성화가 403으로 차단된다 */
export const PLATFORM_DEFAULT_BRAND_NAME = "더 딥스";

export const BRAND_STATUS_FILTER_OPTIONS = [
  { value: "", label: "전체 상태" },
  { value: "true", label: "활성" },
  { value: "false", label: "비활성" },
];

export const BRAND_STATUS_OPTIONS = [
  { value: "true", label: "활성" },
  { value: "false", label: "비활성" },
];

export const BRAND_FORM_INITIAL: AdminBrandCreateRequest = {
  name: "",
  description: "",
  is_active: true,
};

/** 서버의 normalize_brand_name과 동일 규칙 — 중복/길이 판정을 UI에서 미리 맞춘다 */
export const normalizeBrandName = (value: string): string => value.trim().replace(/\s+/g, " ");

/** 브랜드 생성일 표기 — 실행 환경 타임존과 무관하게 KST 로 고정한다 */
export const formatBrandDate = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};
